import { Col, Row } from 'react-bootstrap';
import { Button } from "primereact/button";
import React, { useState } from "react";
import { InputTextarea } from "primereact/inputtextarea";
import { Avatar } from 'primereact/avatar';
import { Sidebar } from 'primereact/sidebar';
import { getSocket } from "../context/socket";
import { useAuth } from '../context/AuthContext';
const MeetingSection = ({ section, cardId }) => {
    const [selectedMeeting, setSelectedMeeting] = useState(null);
    const { userId } = useAuth();
    const [showCommentId, setShowCommentId] = useState(null);
    const [commentText, setCommentText] = useState('');
    const socket = getSocket();

    const handleAddComment = (meeting) => {
        socket.emit("add_card_comment", {
            card_id: cardId,
            card_section_id: section.section_id,
            reference_id: meeting.cardmeeting_id,
            comment_type: "meeting",
            comment_text: commentText,
            user_id: userId
        });

        setCommentText('');
    };

    const handleResolveComment = (comment_id) => {
        socket.emit("resolve_card_comment", {
            card_id: cardId,
            comment_id,
            user_id: userId
        });

    };
    return (
        <>
            <div className="d-flex justify-content-between align-items-start">
                <h6><i className="pi pi-comments me-2 text-danger"></i> <b>{section.section_name}</b></h6>
            </div>
            <div className='taskdataLink'>
                {section.meetings.map((meeting, index) => (
                    <div className={`d-flex align-items-center gap-3 justify-content-between catdHover py-2 ${showCommentId === meeting.cardmeeting_id ? 'example-1' : ''}`} key={meeting.meeting_id}>


                        <p className="mb-0 justify-content-between w-100 position-relative zindex-1" onClick={() => setSelectedMeeting(meeting)}
                            style={{ cursor: 'pointer' }}>
                            <span className='text-primary'>{meeting.meeting_title} ({meeting.meeting_type})</span>
                            <small className="text-secondary d-block" style={{ fontSize: '12px' }}> Last Upadted:<span>{new Date(meeting.updatedAt).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })}</span>
                            </small>
                        </p>


                        <div style={{ width: '100px' }} className="d-flex justify-content-end ">
                            <Button tooltip="View Meeting" icon="pi pi-eye" text severity="secondary" className="border-0 p-0 me-2" onClick={() => setSelectedMeeting(meeting)} />
                            <Button tooltip="Edit Meeting" icon="pi pi-pencil" text severity="secondary" className="border-0 p-0 me-2" />
                            <div className="position-relative">
                                <Button
                                    icon="pi pi-comments"
                                    tooltip="Comment"
                                    className="border-0 p-1"
                                    severity='secondary'
                                    text
                                    onClick={() => setShowCommentId(prev => prev === meeting.cardmeeting_id ? null : meeting.cardmeeting_id)}
                                />
                                {meeting.comments?.length > 0 && (
                                    <span
                                        style={{
                                            position: 'absolute',
                                            top: '-4px',
                                            right: '1px',
                                            background: 'rgb(255 255 255)',
                                            border: '1px solid rgb(228, 45, 119)',
                                            color: 'rgb(228, 45, 119)',
                                            borderRadius: '50%',
                                            width: '15px',
                                            height: '15px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            fontSize: '9px',
                                            fontWeight: '600'
                                        }}
                                    >
                                        {meeting.comments.length}
                                    </span>
                                )}
                            </div>

                            <Button tooltip="Delete" icon="pi pi-times" text severity="danger" className="border-0 p-0" />
                        </div>
                    </div>
                ))}
            </div>
            <div className="p-0">
                {/* Comment popup */}
                {showCommentId && (
                    <div className="img-comment mt-3 ">
                        <Button
                            icon="pi pi-times"
                            className="p-button-text cmtclose"
                            style={{
                                position: 'absolute',
                                top: '-9px',
                                right: '-5px',
                                padding: '0px',
                                background: '#ff0000',
                                width: '20px',
                                height: '20px', 
                                borderRadius: '50% !important',
                                left: 'auto',
                                color: '#fff',
                            }}
                            onClick={() => setShowCommentId(null)}
                        />

                        {section.meetings.find(meeting => meeting.cardmeeting_id === showCommentId)?.comments?.map(comment => (
                            <div
                                key={comment.comment_id}
                                className='d-flex gap-2 comDiv align-items-start mb-2'
                            >
                                <Avatar
                                    image={comment.creator?.profileImage?.image_url}
                                    label={comment.creator?.first_name?.[0]}
                                    shape="circle"
                                />
                                <div className="w-100 position-relative">
                                    <p className="mb-1">
                                        <strong>{comment.creator.first_name} {comment.creator.last_name}</strong>
                                    </p>
                                    <p className="mb-1">{comment.comment_text}</p>
                                    <small className="text-muted d-block mb-2">
                                        {new Date(comment.createdAt).toLocaleString('en-GB', {
                                            day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit',
                                            minute: '2-digit',
                                            hour12: true
                                        })}
                                    </small>

                                    <div className="d-flex justify-content-between">
                                        <Button
                                            title="Resolve"
                                            icon="pi pi-check-circle"
                                            severity="secondary"
                                            text
                                            className="p-0"
                                            onClick={() => handleResolveComment(comment.comment_id)}
                                            style={{
                                                position: 'absolute',
                                                background: 'transparent',
                                                top: '-5px',
                                                right: '-5px',
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>


                        ))}

                        {/* 👇 ADD THIS HERE 👇 */}
                        < div className="mt-3" >
                            <InputTextarea
                                value={commentText}
                                onChange={(e) => setCommentText(e.target.value)}
                                className="px-2 py-1 w-100"
                                placeholder="Add a comment..."
                                rows={2}
                            />
                            <div className="text-end mt-1">
                                <Button
                                    label="Send"
                                    severity="help+"
                                    className="py-1 border-0"
                                    onClick={() =>
                                        handleAddComment(
                                            section.meetings.find(meeting => meeting.cardmeeting_id === showCommentId)
                                        )
                                    }
                                    disabled={!commentText.trim()}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </div >

            {/* Sidebar for viewing full meeting details */}
            <Sidebar
                visible={!!selectedMeeting}
                onHide={() => setSelectedMeeting(null)}
                position="right"
                style={{ width: '40vw' }}
                className="p-sidebar-md meettwo_sidebar"
            >
                {selectedMeeting && (
                    <div>
                        <h5 className='mb-3 text-black'>{selectedMeeting.meeting_title}</h5>
                        <p className='mb-1 text-black'><small className='text-secondary me-2'>Meeting Type:</small> {selectedMeeting.meeting_type}</p>
                        <p className='mb-1 text-black'>
                            <small className='text-secondary me-2'>Date:</small>
                            {new Date(selectedMeeting.date).toLocaleString('en-GB', {
                                day: '2-digit',
                                month: 'short',
                                year: 'numeric',
                            })}
                        </p>

                        <p className='mb-1 text-black'><small className='text-secondary me-2'>Members:</small> {selectedMeeting.meeting_members}</p>
                        <p className='mb-1 text-black d-flex align-items-center gap-2'>
                            <small className='text-secondary me-2'>Updated:</small>
                            <Avatar
                                image={selectedMeeting.cardcreator?.profileImage?.image_url}
                                label={selectedMeeting.cardcreator?.first_name?.[0]}
                                shape="circle"
                                className="me-2"
                                tooltip={`${selectedMeeting.cardcreator?.first_name || ''} ${selectedMeeting.cardcreator?.last_name || ''}`}
                                tooltipOptions={{ position: 'top' }}
                                style={{ border: '1px solid #ddd' }}
                            />
                        </p>
                        <div className='pt-4 mt-4 border-top'>
                            <p><strong>Agenda:</strong><span className='d-block mt-2'>{selectedMeeting.agenda}</span></p>
                            <p><strong>Discussions:</strong><span className='d-block mt-2'>{selectedMeeting.discussions} </span></p>
                            <p><strong>Decisions:</strong><span className='d-block mt-2'>{selectedMeeting.decisions} </span></p>
                            <p><strong>Client Updates:</strong><span className='d-block mt-2'>{selectedMeeting.client_updates} </span></p>
                            <p><strong>Action Items:</strong><span className='d-block mt-2'>{selectedMeeting.action_items} </span></p>
                        </div>
                    </div>
                )}
            </Sidebar>
        </>
    );
};

export default MeetingSection
